import { Stack, Table } from '@chakra-ui/react'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import useGetObject from '@app/hooks/useGetObject'
import RichTextInput from '@app/next/forms/inline/richTextInput'
import ViewerFieldWrapper from '@app/next/forms/inline/support/viewerFieldWrapper'
import DetailsTable from '@app/pages/shared/detailsTable'

const StrategyDetails: FC = () => {
  const { nodeId } = useParams()
  const strategy = useGetObject(nodeId, 'strategy')

  return (
    <Stack gap={4}>
      <Stack gap={4} px={2}>
        <DetailsTable>
          <Table.Body>
            <ViewerFieldWrapper value={strategy.description}>
              <Table.Row>
                <Table.Cell fontWeight="semibold">Description</Table.Cell>
                <Table.Cell>
                  <RichTextInput domainObject={strategy} name="description" placeholder="Description..." />
                </Table.Cell>
              </Table.Row>
            </ViewerFieldWrapper>
          </Table.Body>
        </DetailsTable>
      </Stack>
    </Stack>
  )
}

export default StrategyDetails
